// extracted by mini-css-extract-plugin
export default {"zoomModal":"h4-z","image":"i4-z","button":"j4-z","isOverlayShown":"k4-z"};